import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=1e2015a6&scoped=true&"
import script from "./Cadastro.vue?vue&type=script&lang=ts&"
export * from "./Cadastro.vue?vue&type=script&lang=ts&"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=1e2015a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2015a6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VForm,VIcon,VRow,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2015a6')) {
      api.createRecord('1e2015a6', component.options)
    } else {
      api.reload('1e2015a6', component.options)
    }
    module.hot.accept("./Cadastro.vue?vue&type=template&id=1e2015a6&scoped=true&", function () {
      api.rerender('1e2015a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/geral/relacaoDocumento/Cadastro.vue"
export default component.exports